<div class="container">
  <div class="modal">
    <h1 *ngIf="title" class="modal__header">{{title}}</h1>
    <div class="modal__content">
      <p [innerHTML]="description"></p>
    </div>

    <div class="modal__footer">
      <ion-button color="clear" (click)="cancel()"
        >{{ 'common.cancel' | transloco }}</ion-button
      >
      <ion-button color="dark" (click)="ok()"
        >{{ 'common.ok' | transloco }}</ion-button
      >
    </div>
  </div>
</div>
